import {
    Clock3,
    Mail,
    Shield,
    RotateCcw,
    X,
} from "lucide-react";

import {
    NEED_HELP_TEXT,
    NEED_HELP_REASONS,
    NEED_HELP_STEPS,
} from "../../domain/constants/constants";


type Props = {
    onClose: () => void;
};
const ICONS = {
    clock: <Clock3 size={18} />,
    mail: <Mail size={18} />,
    shield: <Shield size={18} />,
    refresh: <RotateCcw size={18} />,
};

export default function NeedHelpModal({
    onClose,
}: Props) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0B1B14]/65 backdrop-blur-sm p-4 sm:p-6">

            <div className=" relative w-full max-w-[95vw] sm:max-w-[410px] rounded-[24px]  bg-white shadow-2xl max-h-[90vh] overflow-y-auto sm:max-h-fit  sm:overflow-visible">
                {/* Close */}
                <button
                    onClick={onClose}
                    className="absolute right-5 top-5 flex h-8 w-8 items-center justify-center rounded-lg border border-[#E6E1D6] bg-[#F7F4EC]"
                >
                    <X size={16} />
                </button>

                <div className="px-5 py-5">

                    <h2 className="font-fraunces text-[22px] font-medium text-[#13211B]">
                        {NEED_HELP_TEXT.title}
                    </h2>

                    {/* COMMON REASONS */}

                    <p className="mt-3 text-[10px] font-bold tracking-[1.5px] text-[#B3B8B3]">
                        {NEED_HELP_TEXT.commonReasons}
                    </p>

                    <div className="mt-2">

                        {NEED_HELP_REASONS.map((item, index) => (
                            <div
                                key={index}
                                className="flex gap-3 border-b border-[#ECE8DD] py-2.5 last:border-0"
                            >
                                <div className="mt-1 text-[#7C8883]">
                                    {ICONS[item.icon as keyof typeof ICONS]}
                                </div>

                                <div>
                                    <h3 className="text-[15px] font-semibold text-[#13211B]">
                                        {item.title}
                                    </h3>

                                    <p className="mt-0 text-[12px] leading-5 text-[#6E7A75]">
                                        {item.text}
                                    </p>
                                </div>
                            </div>
                        ))}

                    </div>

                    {/* WHAT TO TRY */}

                    <p className="mt-3 text-[10px] font-bold tracking-[1.5px] text-[#B3B8B3]">
                        {NEED_HELP_TEXT.whatToTry}
                    </p>

                    <div className="mt-3 space-y-3">

                        {NEED_HELP_STEPS.map((step, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-3"
                            >
                                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-[#EAF8F2] text-[11px] font-semibold text-[#1D9E75]">
                                    {index + 1}
                                </div>

                                <span className="text-[14px] text-[#47524D]">
                                    {step}
                                </span>
                            </div>
                        ))}

                    </div>

                    {/* Support */}

                    <div className="mt-3 rounded-2xl border border-[#E7E2D8] bg-[#F8F6EF] p-3">

                        <h3 className="text-[15px] font-semibold text-[#13211B]">
                            {NEED_HELP_TEXT.supportTitle}
                        </h3>

                        <p className="mt-1 text-[13px] text-[#6E7A75]">
                            {NEED_HELP_TEXT.supportDescription}
                        </p>

                        <p className="mt-1 text-[13px] font-medium text-[#6E7A75]">
                            {NEED_HELP_TEXT.supportEmail}
                        </p>

                    </div>

                    {/* Close */}

                    <button
                        onClick={onClose}
                        className="mt-3 h-10 w-full rounded-2xl border border-[#DED8CC] bg-[#F7F4EC] text-[15px] font-semibold text-[#13211B] hover:bg-[#F2EFE7]"
                    >
                        {NEED_HELP_TEXT.close}
                    </button>

                </div>
            </div>
        </div>
    );
}